import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";

// 导入布局组件
import Layout from "./components/Layout/Layout";

// 导入页面组件
import TimestampConverter from "./components/TimestampConverter/TimestampConverter";
import Md5Generator from "./components/Md5Generator/Md5Generator";
import TestPage from "./components/TestPage/TestPage";
import Profile from "./components/Profile/Profile";
import Settings from "./components/Settings/Settings";
import MovePage from "./components/MovePage/MovePage";
function App() {
  return (
    <Router basename="/react">
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* 默认重定向到时间戳转换页面 */}
            <Route index element={<Navigate to="/timestamp" replace />} />

            {/* 功能页面路由 */}
            <Route path="/timestamp" element={<TimestampConverter />} />
            <Route path="/md5" element={<Md5Generator />} />
            <Route path="/test" element={<TestPage />} />
            <Route path="/move" element={<MovePage />} />

            {/* 用户相关页面 */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />

            {/* 404页面 */}
            <Route path="*" element={<Navigate to="/timestamp" replace />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
